import styled from 'styled-components';

import { Toolbar as InternalToolbar } from '@xing-com/content-editor-toolbar';
import { spaceS, xdlColorBorderSoft } from '@xing-com/tokens';

export const Toolbar = styled(InternalToolbar)`
  border-bottom: 1px solid ${xdlColorBorderSoft};
  padding: ${spaceS} 0;
`;
